import './gift-info-table.scss';

import { EditorViewer } from '@common/components/organism/EditorViewer';
import { cn } from '@core/utils';

import { TABS } from '../../../constants';

interface GiftTabContentInfoProps {
  productInfo: string;
}

export const GiftTabContentInfo = ({
  productInfo,
}: GiftTabContentInfoProps) => {
  return (
    <section
      className={cn(
        'flex flex-col gap-12 pb-120 *:px-0',
        'mobile-tablet:gap-12 mobile-tablet:px-20 mobile-tablet:pb-60',
      )}
      id={TABS.INFO}
    >
      <h2
        className={cn(
          'pb-16 pt-32 text-[40px] font-600 text-Gray-900',
          'mobile-tablet:pb-8 mobile-tablet:pt-16 mobile-tablet:typo-body1',
        )}
      >
        상품 기본 정보
      </h2>
      <EditorViewer content={productInfo} className="gift-info-table" />
    </section>
  );
};
